import { ENTERPRISE } from 'self-service-api/constants/ProductLevels';
import { SegmentedTabNavItems } from '../../constants/routing/NavItems';
import { orderedTabs } from '../../constants/routing/Tabs';
/**
 * When deployed, the pricing pages should just be under
 * '/public-pricing', however when testing locally and on the proxy during dev
 * we have different URLs (e.g. /public-pricing-pt-br-service) that'll break
 * if we don't grab the path dynamically
 */
export const getPublicPagePath = () => {
  return `/${window.location.pathname.split('/')[1]}`;
};

/**
 * Gets the product line from the path if it exists
 *
 * Examples:
 *  /pricing -> ''
 *  /pricing/ -> ''
 *  /pricing/bundle -> ''
 *  /pricing/sales -> 'enterprise'
 *  /pricing/marketing/professional -> enterprise
 *  /pricing/sales/professional -> 'enterprise'
 *  /pricing/marketing/enterprise -> enterprise
 *  /pricing/sales/starter -> 'starter'
 */
export const getProductLevelFromPath = path => {
  const pathParts = path.split('/').filter(Boolean);
  const productLine = pathParts[1];

  // check if the page is event a tab supported page
  const isTabSupportedPage = SegmentedTabNavItems.includes(productLine);

  // check the path for a product level (enterprise or starter)
  const foundProductLevel = pathParts.find(slug => orderedTabs.includes(slug));
  return foundProductLevel || (isTabSupportedPage ? ENTERPRISE.toLowerCase() : '');
};